import { render, staticRenderFns } from "./OrganisationForm.vue?vue&type=template&id=657091de&scoped=true"
import script from "./OrganisationForm.vue?vue&type=script&lang=js"
export * from "./OrganisationForm.vue?vue&type=script&lang=js"
import style0 from "./OrganisationForm.vue?vue&type=style&index=0&id=657091de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657091de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657091de')) {
      api.createRecord('657091de', component.options)
    } else {
      api.reload('657091de', component.options)
    }
    module.hot.accept("./OrganisationForm.vue?vue&type=template&id=657091de&scoped=true", function () {
      api.rerender('657091de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Organisation/Edit/OrganisationForm.vue"
export default component.exports